import { Component, OnInit, ViewChild } from '@angular/core';
// import IgxCategoryChart
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke,
  ApexYAxis
} from "ng-apexcharts";
import { SharedService } from '../../../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from '../../../learning-center/components/my-dashboard/my-dashboard.service';
import { AnalyticsService } from './analytics.service';
import { UsersService } from '../../../management/components/tabs/components/users/users.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
};
@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
    ])
  ]
})
export class AnalyticsComponent implements OnInit {
	headerTitle = " ";
	@ViewChild("chart") chart!: ChartComponent;
	public chartOptions!: Partial<ChartOptions> | any;
	userProgress: any;
	hasProgress: boolean = false;
	blockLoader: string = "blockLoader";
	weeklyTime:any;
	categories: any;
	progressBar: any = [];
	activePrograms: any = [];
	numProgramsCompleted: any = 0;
	averageQuizScore: number = 0;
	companyAverage: number = -1;
	industryAverage: number = -1;
	totalEarnedPts: number = 0;
	monthlyAverage: number = 0;
	lifetimeDoses: number = -1;
	currentMonth: string = '';
	userData: any;
	userName:any;
	userPic:any;

	notStartedCount:number=0;
	inProgressCount:number=0;
	completedCount:number=0;
	easyCount:number=0;
	mediumCount:number=0;
	hardCount:number=0;
	totalLevelCount:number=0;
	totalProgressCount:number=0;
	totalViewTime = "0m";
	totalViewTimeSeconds: number = 0;
	userMonthsOnSystem: number = 1;
	orgData: any;

	constructor(
		private sharedService: SharedService,
		private spinner: NgxSpinnerService,
		private dashboardService: DashboardService,
		private analyticsService: AnalyticsService,
		private usersService: UsersService,
		private fns: AngularFireFunctions,
		private http: HttpClient
	) {
		this.chartOptions = {
		colors: ['#7775EA'],

		grid: {
			show: false,      // you can either change hear to disable all grids
		},

		series: [

			{
			name: "series1",
			data: [10, 20, 30]
			},

		],
		chart: {
			height: 80,
			// width: 170,ana
			type: "area",
			toolbar: {
			show: false,
			}
		},
		dataLabels: {
			enabled: false
		},
		stroke: {
			curve: "smooth"
		},

		yaxis: {
			axisTicks: {
			show: false
			},
			axisBorder: {
			show: false
			},

			min: 0, max: 100, tickInterval: 25,
			title: {
			text: "title"
			},

		},

		xaxis: {
			axisTicks: {
			show: false
			},
			axisBorder: {
			show: false
			},
			lines: {
			show: false
			},
			labels: {
			show: false
			},
			type: "area",
		},
		tooltip: {
			x: {
			// format: "dd/MM/yy HH:mm"
			}
		}
		};

		this.sharedService.activePrograms$.subscribe(activePrograms => {
			// console.log(activePrograms);
			this.activePrograms = activePrograms;
			this.sortActiveProgramsByAccessOrder();
			this.numProgramsCompleted = this.getProgramsCompleted();
			if (this.activePrograms.length >= 1) {
				this.hasProgress = true;
			} else {
				this.hasProgress = false;
			}

			// for (let program of this.activePrograms) {
			// 	this.daysInRow += Number(this.getDaysInRow(program.daysInRow));
			// 	this.learningThisMonth += Number(this.getLearningMinutesThisMonth(program.learningHistory));
			// }

			// this.showCurrentMonthDates();
		});

		const newDate = new Date();
		if ((newDate.getMonth() + 1) <= 9) {
			this.currentMonth += `0${(newDate.getMonth() + 1)}`;
		} else {
			this.currentMonth += `${(newDate.getMonth() + 1)}`;
		}
		this.currentMonth += `-${newDate.getFullYear()}`;
	}

	sortActiveProgramsByAccessOrder() {
		this.activePrograms.sort(function sortByAccessOrder(programA: any, programB: any) {
			if (programA.lastUpdatedAt > programB.lastUpdatedAt) {
				return -1;
			} else if (programA.lastUpdatedAt < programB.lastUpdatedAt) {
				return 1;
			}

			return 0;
		});
	}

	getProgramsCompleted() {
		let count = 0;
		for (let program of this.activePrograms) {
			if (program.progress === 100) {
				count += 1;
			}
		}
		return count;
	}

	async ngOnInit() {
		this.userName = localStorage.getItem('firstName');
		this.userPic = localStorage.getItem('userPic');
		await this.spinner.show("blockLoader");
		await this.getUserProgress();
		await this.getOrgData();
		this.companyAverage = (this.orgData && this.orgData.companyAverage) ? this.orgData.companyAverage : 0;

		this.getCountCourseLevel();
		this.progressProgram();

		this.getCategories();
		this.userData = await this.dashboardService.getUserData();
		await this.spinner.hide("blockLoader");
		this.userMonthsOnSystem = this.getUserMonthsOnSystem(this.userData);
		// console.log(this.userMonthsOnSystem);
		this.lifetimeDoses = this.getLifetimeDoses();
		this.totalEarnedPts = this.getEarnedPoints();
		this.monthlyAverage = this.getMonthlyAverage();
		this.totalViewTime = this.getTotalViewTime();
		this.weeklyTime = this.getAvgWeeklyTime();
		// await this.generateCompanyAverage();
		await this.generateIndustryAverage();
		// this.userName = localStorage.getItem('firstName');
		// this.userPic = localStorage.getItem('userPic');
	}

	public generateData(baseval: any, count: any, yrange: any) {
		var i = 0;
		var series = [];

		while (i < count) {
			var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
			var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
			var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
			series.push([x, y, z]);
			baseval += 86400000;
			i++;
		}
		return series;
	}

	// getPrograms(){
	// 	const userId = localStorage.getItem('userId');
	// 	console.log('userId',userId);
	// 	let programs;
	// 	this.analyticsService.getPrograms(userId).subscribe(data => {
	// 		programs = data;
	// 		console.log(programs);
	// 	});
	// 	console.log(programs);
	// }

	async getUserProgress() {
		this.averageQuizScore = 0;
		const userId = localStorage.getItem('userId');
		// console.log(typeof userId)
		this.userProgress = await this.dashboardService.getUserProgressAnalytics(userId);

		if (this.userProgress?.length >= 1) {
			this.hasProgress = true;
			let quizAnswerProgress = 0;
			let count = 0;
			this.userProgress.forEach((progress: any) => {
				if (progress.attemptedQuizzes >= 1) {
					quizAnswerProgress += progress.quizAnswerProgress;
					count += 1
				}
			});

			if (count !== 0) {
				this.averageQuizScore = Math.round(quizAnswerProgress/count);
			}

			// console.log('userProgress',quizAnswerProgress , count)
			// this.showCurrentMonthDates();
		} else {
			this.hasProgress = false;
		}

	}

	async getOrgData() {
		const orgId = localStorage.getItem('orgId');
		if (orgId) {
			this.orgData = await this.analyticsService.getOrgData(orgId);
		}
	}

	getCategories() {
		this.analyticsService.getCategories().subscribe((cat: any) => {
			this.progressBar = [];

			this.categories = cat;
			// console.log(this.categories);
			this.categories.forEach((category: any) => {
				this.progressBar.push({
					name: category.name,
					id: category.id,
					progressNumber: 0,
					progressPercentage: 0
				});
			});

			this.userProgress.forEach((program: any) => {
				this.progressBar.forEach((process:any, index:number) => {
					if (process.id === program.category.id) {
						this.progressBar[index].progressNumber += 1;
					}
				})
			});
			// console.log('progressBar', this.progressBar);
			this.progressBar.forEach((process:any) => {
				if(process.progressNumber > 0){
					process.progressPercentage = (process.progressNumber / this.userProgress.length) * 100;
				}
			})

			// console.log('progressBar', this.progressBar);
			this.progressBar = this.progressBar.sort((a:any, b:any) => b.progressPercentage - a.progressPercentage);
			// console.log('sort', this.progressBar);
		});

	}

	getDosesCompleted() {
		let dosesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1) {
					for (let monthKey of Object.keys(program.dosesCompleted)) {
						const doses = program.dosesCompleted[monthKey];
						for (let dateKey of Object.keys(doses)) {
							dosesCompleted += doses[dateKey];
						}
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress)  {
				if (item.progress === 100) {
					dosesCompleted += 1;
				}
			}
		}

		return dosesCompleted;
	}

	getLastSection(sections: any): any {
		let lastSection: any;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					const lastSec = this.getLastSection(section.menu);
					lastSection = lastSec;
				} else {
					lastSection = section;
				}
			}
		}

		return lastSection;
	}

	getFirstPendingSection(sections: any): any {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					const firstPendingSection = this.getFirstPendingSection(section.menu);

					if (firstPendingSection && Object.keys(firstPendingSection)?.length >= 1) {
						return firstPendingSection;
					} else {
						continue;
					}
				} else if (section.progress !== 100) {
					return section;
				}
			}
		}
	}

	getQuizzesCompleted() {
		let totalQuizzes;
		let quizProgress;
		let result = 0;
		for(let i = 0; i < this.userProgress?.length; i++) {
			totalQuizzes = 0;
			quizProgress = 0;
			totalQuizzes = this.userProgress[i].totalQuizzes;
			quizProgress = this.userProgress[i].quizProgress;
			result += Math.round((quizProgress / 100) * totalQuizzes);
			// console.log(result);
		}
		// console.log(result);
		return result;
		// console.log(quizProgress);
		// return Math.round((quizProgress / 100) * totalQuizzes);
	}

	getEarnedPoints() {
		let earnedPts = 0;
		for (let i = 0; i < this.userProgress?.length; i++) {
			earnedPts += this.userProgress[i].earnedPts;
		}

		for (let program of this.userProgress) {
			earnedPts += this.getTotalEarnedPts(program.sections);
		}

		return Math.ceil(earnedPts);
	}

	getTotalEarnedPts(sections: any) {
		let earnedPts = 0;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					earnedPts += this.getTotalEarnedPts(section.menu);
				} else if (section.type === 'video' || section.type === 'download') {
					if (section.progress && section.pts) {
						const videoPts = (section.pts * section.progress) / 100;
						// console.log(videoPts);
						earnedPts += videoPts;
					}
				}
			}
		}

		return earnedPts;
	}

	getCountCourseLevel(level?: string) {
		let easyNumber = 0;
		let mediumNumber = 0;
		let hardNumber = 0;

		for (let i = 0; i < this.userProgress?.length; i++) {
			if (this.userProgress[i].difficultyLevel == 'easy') {
				easyNumber++;
			}
			if (this.userProgress[i].difficultyLevel == 'medium') {
				mediumNumber++;
			}
			if (this.userProgress[i].difficultyLevel == 'hard') {
				hardNumber++;
			}
		}

		// if (level == 'easy') return easyNumber;
		// else if (level == 'medium') return mediumNumber;
		// else if (level == 'hard') return hardNumber;

		this.easyCount = easyNumber ? easyNumber : 0;
		this.mediumCount = mediumNumber ? mediumNumber : 0;
		this.hardCount = hardNumber ? hardNumber : 0;
		this.totalLevelCount = this.easyCount + this.mediumCount + this.hardCount;
	}

	progressProgram(progress?:string){
		let inProgressCount = 0;
		let notStartedCount = 0;
		let completedCount = 0;

		for (let i = 0; i < this.userProgress?.length; i++) {
			if(this.userProgress[i].progress === 100) completedCount++;
			else if(this.userProgress[i].progress < 100 && this.userProgress[i].progress > 0) inProgressCount++;
			else if(this.userProgress[i].progress === 0) notStartedCount++;
		}

		// if(progress === 'inProgress') return inProgressCount;
		// else if(progress === 'notStarted') return notStartedCount;
		// else if(progress === 'completed') return completedCount;

		this.inProgressCount = inProgressCount ? inProgressCount : 0;
		this.notStartedCount = notStartedCount ? notStartedCount : 0;
		this.completedCount = completedCount ? completedCount : 0;
		this.totalProgressCount = this.inProgressCount + this.notStartedCount + this.completedCount;
	}

	getProgressPercentage(totalCount:number, count: number): number {
		if (totalCount === 0) {
		  return 0;
		}
		return (count / totalCount) * 100;
	}

	getTotalViewTime() {
		this.totalViewTimeSeconds = 0;

		for (let i = 0; i < this.userProgress?.length; i += 1) {
			let progressI = this.userProgress[i];

			for (let section of progressI.sections) {
				for (let unit of section.menu) {
					if (unit.type === "video" && unit?.metadata?.topics) {
						for (let topic of unit.metadata.topics) {
							if (topic.learningDuration) {
								this.totalViewTimeSeconds += topic.learningDuration;
							}
						}
					}
				}
			}
		}

		const minutes = Math.ceil(this.totalViewTimeSeconds / 60);
		if (minutes >= 60) {
			return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
		} else {
			return `${minutes}m`;
		}
	}

	// getAvgWeeklyTime() {
	// 	let currDate = new Date();
	// 	let currMonthKey = `${((currDate.getMonth() + 1) < 10) ? ('0' + Number(currDate.getMonth() + 1)) : Number(currDate.getMonth() + 1)}-${currDate.getFullYear()}`;

	// 	const historyThisMonth = this.userProgress.learningHistory[currMonthKey];
	// 	let daysThisMonth;

	// 	if (this.userProgress.daysLoggedHistory[currMonthKey]) {
	// 		daysThisMonth = this.userProgress.daysLoggedHistory[currMonthKey].length;
	// 	}

	// 	if (daysThisMonth) {
	// 		const duration = historyThisMonth / daysThisMonth;
	// 		const minutes = Math.ceil(duration / 60);
	// 		if (minutes >= 60) {
	// 			return `${minutes / 60}h ${minutes % 60}m`;
	// 		} else {
	// 			return `${minutes}m`;
	// 		}
	// 	}

	// 	return 0;
	// }

	getAvgWeeklyTime() {
		// let duration = 0;

		// for (let i = 0; i < this.userProgress?.length; i++) {
		// 	let weeklyTime = this.userProgress[i].learningHistory;
		// 	for (let key of Object.keys(weeklyTime)) {
		// 		if (key === this.currentMonth) {
		// 			duration += weeklyTime[key];
		// 		}
		// 	}
		// }

		// duration /= 4;

		let duration = this.totalViewTimeSeconds / (this.userMonthsOnSystem * 4);
		const minutes = Math.ceil(duration / 60);
		if (minutes >= 60) {
			return  `${Math.round(minutes / 60)}h ${minutes % 60}m`;
		} else {
			return  `${minutes}m`;
		}
	}

	getOrganisation() {
		let organisation:any;
		this.analyticsService.getOrganisation().subscribe((data) => {
			if(data.length) {
				organisation = data;
				organisation.forEach(async (org:any) => {
					await this.updateOrganisation(org);
				})
			}
		});
	}

	async updateOrganisation(organisation:any){
		let org:any = organisation;
		// console.log(org);
		org.hierarchy.forEach((item: any) => {
			item.name = item.name.toLowerCase()
			item.values.forEach((el: any) => {
				el.displayValue = el.value
				el.value = el.value.toLowerCase();
				if(el.levels.length){
					// console.log('el.levels.length',el.levels.length);
					for(let i = 0; i < el.levels.length; i++){
						// console.log('el.levels',el.levels[i]);
						el.levels[i] = el.levels[i].toLowerCase();
						// console.log('el.levels',el.levels[i]);
					}
				}
			});
			// console.log(item);

		});
		// console.log('org',org);
		await this.analyticsService.addEditOrganization(org, org.id);
	}

	async generateCompanyAverage() {
		// const orgId = localStorage.getItem('orgId') ?? '';

		// if (orgId) {
			// const allUsersInOrg = await this.usersService.getAllUsersInOrg(orgId);
			// console.log(allUsersInOrg.length);
			// const allPrograms: any = await this.sharedService.getProgressWithUserIds(allUsersInOrg);
		// 	const getAnalyticsData = this.fns.httpsCallable('analytics-getAnalyticsDatav2');
		// 	const getAnalyticsDataObs = getAnalyticsData({ orgId });
		// 	const getAnalyticsRes: any = await this.sharedService.getObservableRes(getAnalyticsDataObs);
		// 	const mergedData = getAnalyticsRes.mergedData;

		// 	let allUsersAverageDosesTotal = 0;
		// 	for (let user of mergedData) {
		// 		let userTotalDoses = 0;
		// 		for (let program of user.progressData) {
		// 			const programDoses = this.sharedService.getDosesCompletedForProgram(program);
		// 			userTotalDoses += programDoses;
		// 		}
		// 		userTotalDoses += this.sharedService.getUserPodcastDoses(user);
		// 		userTotalDoses += this.sharedService.getUserMiniclipDoses(user);

		// 		let userMonthsOnSystem = this.getUserMonthsOnSystem(user);
		// 		user.avgMonthlyDoses = userTotalDoses / userMonthsOnSystem;
		// 		if (!user.avgMonthlyDoses || isNaN(user.avgMonthlyDoses)) {
		// 			user.avgMonthlyDoses = 0;
		// 		}

		// 		allUsersAverageDosesTotal += user.avgMonthlyDoses;
		// 	}

		// 	this.companyAverage = Math.round(allUsersAverageDosesTotal / mergedData.length);
		// } else {
		// 	this.companyAverage = 0;
		// }
	}

	async generateIndustryAverage() {
		// const allUsers = await this.usersService.getAllUserIdsAllOrgs();
		// console.log(allUsers);
		// const getAnalyticsData = this.fns.httpsCallable('analytics-getAnalyticsDatav2');
		// const getAnalyticsDataObs = getAnalyticsData({});
		// const getAnalyticsRes: any = await this.sharedService.getObservableRes(getAnalyticsDataObs);
		// const data = getAnalyticsRes.mergedData;

		// if (!data || (data && data.length <= 0)) {
		// 	this.industryAverage = 0;
		// 	return;
		// }

		// // let allPrograms: any = [];
		// let allUsersAverageDosesTotal = 0;

		// for (let user of data) {
		// 	let userTotalDoses = 0;
		// 	for (let program of user.progressData) {
		// 		const programDoses = this.sharedService.getDosesCompletedForProgram(program);
		// 		userTotalDoses += programDoses;
		// 	}

		// 	userTotalDoses += this.sharedService.getUserPodcastDoses(user);
		// 	userTotalDoses += this.sharedService.getUserMiniclipDoses(user);

		// 	let userMonthsOnSystem = this.getUserMonthsOnSystem(user);
		// 	user.avgMonthlyDoses = userTotalDoses / userMonthsOnSystem;
		// 	if (!user.avgMonthlyDoses || isNaN(user.avgMonthlyDoses)) {
		// 		user.avgMonthlyDoses = 0;
		// 	}

		// 	allUsersAverageDosesTotal += user.avgMonthlyDoses;
		// }

		// this.industryAverage = Math.round(allUsersAverageDosesTotal / data.length);

		const communityAnalytics: any = await this.analyticsService.getCommunityAnalytics();
		this.industryAverage = communityAnalytics.industryAverage;
	}

	getUserMonthsOnSystem(user: any) {
		if (!user.createdAt) {
			return 1;
		}
		return this.sharedService.getMonthsFromCurrent(user.createdAt);
	}

	getDosesCompletedForProgram(programData: any) {
		let dosesCompleted = 0;
		if (programData.progress === 100) {
			const lastSection = this.getLastSection(programData.sections);
			dosesCompleted += lastSection?.dfs;
		} else {
			const firstPendingSection = this.getFirstPendingSection(programData.sections);
			// console.log(firstPendingSection);
			dosesCompleted += Number(firstPendingSection?.dfs) - 1;
		}

		if (dosesCompleted >= 1) {
			return dosesCompleted;
		}
		return dosesCompleted;
	}

	getMonthlyAverage() {
		let dosesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				if (program.dosesCompleted) {
					for (let monthKey of Object.keys(program.dosesCompleted)) {
						for (let dateKey of Object.keys(program.dosesCompleted[monthKey])) {
							dosesCompleted += Number(program.dosesCompleted[monthKey][dateKey]);
						}
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed && clip.completedAt) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress)  {
				if (item.progress === 100 && item.completedAt) {
					dosesCompleted += 1;
				}
			}
		}

		// console.log(dosesCompleted);
		return Math.round(dosesCompleted / this.userMonthsOnSystem);
	}

	getMonthOfDate(date: any) {
		if (date) {
			let newDate: any;
			if (date.seconds && date.nanoseconds) {
				newDate = new Date(date.seconds * 1000);
			} else if (date._seconds && date._nanoseconds) {
				newDate = new Date(date._seconds * 1000);
			}
			const month = (newDate.getMonth() + 1) < 10 ? "0" + newDate.getMonth() + 1 : String(newDate.getMonth() + 1);
			const year = newDate.getFullYear();
			return `${month}${year}`;
		}

		return "";
	}

	getLifetimeDoses() {
		let dosesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1) {
					for (let monthKey of Object.keys(program.dosesCompleted)) {
						const doses = program.dosesCompleted[monthKey];
						for (let dateKey of Object.keys(doses)) {
							dosesCompleted += doses[dateKey];
						}
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress)  {
				if (item.progress === 100) {
					dosesCompleted += 1;
				}
			}
		}

		return dosesCompleted;
	}

	flip1: string = 'inactive';
	flip2: string = 'inactive';
	flip3: string = 'inactive';
	flip4: string = 'inactive';
	flip5: string = 'inactive';
	flip6: string = 'inactive';

	toggleFlip(itemNumber: number) {
		if (itemNumber === 1) {
			this.flip1 = (this.flip1 == 'inactive') ? 'active' : 'inactive';
		} else if (itemNumber === 2) {
			this.flip2 = (this.flip2 == 'inactive') ? 'active' : 'inactive';
		}else if (itemNumber === 3) {
			this.flip3 = (this.flip3 == 'inactive') ? 'active' : 'inactive';
		}else if (itemNumber === 4) {
			this.flip4 = (this.flip4 == 'inactive') ? 'active' : 'inactive';
		}else if (itemNumber === 4) {
			this.flip4 = (this.flip4 == 'inactive') ? 'active' : 'inactive';
		}else if (itemNumber === 5) {
			this.flip5 = (this.flip5 == 'inactive') ? 'active' : 'inactive';
		}else if (itemNumber === 6) {
			this.flip6 = (this.flip6 == 'inactive') ? 'active' : 'inactive';
		}
	}

}
